export * from "-!../../../developer-tools/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../developer-tools/node_modules/pug-plain-loader/index.js!./WSPDSC01-product-description.pug?vue&type=template&id=1b5429ba&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ../source/modules/WSPDSC01-product-description/WSPDSC01-product-description.pug?vue&type=template&id=1b5429ba&lang=pug&
// module id = 1210
// module chunks = 7